import React, { useState } from "react";
import Colors from "../components/Colors";
import { Box, Button, Typography } from "@mui/material";
import SliderRapidRiddle from "../components/sliderRapidRiddle";
import FloatingSocialIcons from "./SocialMedia";
import Header from "../components/Header";
import ramadan from "../images/ramadan.jpg";
import movies from "../images/movies.png";
import Footer from "../components/Footer";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import easter from "../images/easter.png";
import vishu from "../images/vishu.png";
import axios from "axios";
import { API_URL } from "../components/Constant";
import { Category } from "@mui/icons-material";

function RapidRiddleLanding() {
  const [notifiedGames, setNotifiedGames] = useState({});

  const handleRApidGameClick = async (game) => {
    localStorage.setItem("RapidGame", game);
    localStorage.removeItem("TimelessTiesTocken");
    localStorage.removeItem("BackToBenchTocken");
    window.location.href = "/waiting-room";
  };

  const handleRApidNotificationClick = async (game) => {
    try {
      // Register the player
      const response = await axios.post(`${API_URL}/insert_notification`, {
        PlayerTocken: localStorage.getItem("PlayerTocken"),
        gameCategory: game,
      });
      if (response.data.success) {
        setNotifiedGames((prev) => ({
          ...prev,
          [game]: true,
        }));
      }
    } catch (error) {
      console.error("Something went wrong:", error);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "8px",
        background: Colors.bgColor,
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Box sx={{ width: "100%", zIndex: 101, position: "relative" }}>
        <Header />
      </Box>

      <SliderRapidRiddle />

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "column" },
          width: "100%",
          justifyContent: "center",
          height: "100%",
          background: Colors.rapidbg,
          alignItems: "center",
          marginTop: { md: "2.5%", xs: "5%" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: { md: "5%", xs: "60px" },
            maxWidth: "90%",
            maxHeight: "90%",
            paddingBottom: { md: "2.5%", xs: "5%" },
            paddingTop: { md: "2.5%", xs: "5%" },
            width: "100%",
            flexWrap: "wrap", // Ensures items wrap to the next line
            justifyContent: { md: "flex-start", xs: "center" }, // Centers the items
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: { md: "28%", xs: "90%" },
              borderRadius: "16px",
              padding: "12px",
              position: "relative",
              overflow: "hidden",
              "&::before, &::after": {
                content: '""',
                position: "absolute",
                width: "25%", // Adjust corner border size
                height: "25%",
                borderColor: "#e9c87d",
              },
              "&::before": {
                top: 0,
                left: 0,
                borderTop: "4px solid",
                borderLeft: "4px solid",
                borderColor: "#5b3b17",
              },
              "&::after": {
                bottom: 0,
                right: 0,
                borderBottom: "4px solid",
                borderRight: "4px solid",
                borderColor: "#5b3b17",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "100%",minHeight:{md:'100%', xs:'340px'},
                borderRadius: "16px",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {/* Image */}
              <img
                alt="profile"
                src={vishu}
                style={{
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                  borderRadius: "16px",
                  objectFit: "cover",
                }}
              />

              {/* Black Overlay */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: {
                    md: "rgba(0, 0, 0,0.7)",
                    xs: "rgba(0, 0, 0,0.5)",
                  },
                  borderRadius: "16px",
                }}
              />

              {/* Ramadan Special Label (Centered) */}
              <Typography
                variant="h6"
                sx={{
                  position: "absolute",
                  top: "40%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  fontWeight: "bold",
                  fontSize: { md: "44px", xs: "34px" },
                  fontFamily: "Boogaloo",
                  color: "#fff",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
              >
                Vishu Special
              </Typography>

              {/* Stay Notified Button (Top-Left) */}
              <Button
                variant="contained"
                sx={{
                  position: "absolute",
                  top: "32px",
                  left: "32px",
                  backgroundColor: "#e9c87d",
                  color: "#000",
                  fontSize: { md: "14px", xs: "12px" },
                  padding: { md: "6px 16px", xs: "4px 12px" },
                  minWidth: "140px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  "&:hover": { backgroundColor: "#e9c87d" },
                }}
                onClick={() => handleRApidNotificationClick("Vishu")}
              >
                <NotificationsActiveIcon fontSize="small" />{" "}
                {notifiedGames["Vishu"] ? "Subscribed!" : "Stay Notified"}
              </Button>

              {/* Play Now Button (Bottom-Right) */}
              <Button
                variant="contained"
                sx={{
                  position: "absolute",
                  top: "55%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "#e9c87d",
                  color: "#000",
                  fontSize: { md: "14px", xs: "12px" },
                  padding: { md: "6px 16px", xs: "4px 12px" },
                  minWidth: "140px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  "&:hover": { backgroundColor: "#e9c87d" },
                }}
                onClick={() => handleRApidGameClick("Vishu")}
              >
                <PlayArrowIcon fontSize="small" /> Play Now
              </Button>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              width: { md: "28%", xs: "90%" },
              borderRadius: "16px",
              padding: "12px",
              position: "relative",
              overflow: "hidden",
              "&::before, &::after": {
                content: '""',
                position: "absolute",
                width: "25%", // Adjust corner border size
                height: "25%",
                borderColor: "#e9c87d",
              },
              "&::before": {
                top: 0,
                left: 0,
                borderTop: "4px solid",
                borderLeft: "4px solid",
                borderColor: "#5b3b17",
              },
              "&::after": {
                bottom: 0,
                right: 0,
                borderBottom: "4px solid",
                borderRight: "4px solid",
                borderColor: "#5b3b17",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "100%",
                borderRadius: "16px",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {/* Image */}
              <img
                alt="profile"
                src={movies}
                style={{
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                  borderRadius: "16px",
                  objectFit: "cover",
                }}
              />

              {/* Black Overlay */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: {
                    md: "rgba(0, 0, 0,0.7)",
                    xs: "rgba(0, 0, 0,0.5)",
                  },
                  borderRadius: "16px",
                }}
              />

              {/* Ramadan Special Label (Centered) */}
              <Typography
                variant="h6"
                sx={{
                  position: "absolute",
                  top: "40%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  fontWeight: "bold",
                  fontSize: { md: "44px", xs: "34px" },
                  fontFamily: "Boogaloo",
                  color: "#fff",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
              >
                Movie Special
              </Typography>

              {/* Stay Notified Button (Top-Left) */}
              <Button
                variant="contained"
                sx={{
                  position: "absolute",
                  top: "32px",
                  left: "32px",
                  backgroundColor: "#e9c87d",
                  color: "#000",
                  fontSize: { md: "14px", xs: "12px" },
                  padding: { md: "6px 16px", xs: "4px 12px" },
                  minWidth: "140px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  "&:hover": { backgroundColor: "#e9c87d" },
                }}
                onClick={() => handleRApidNotificationClick("Movie")}
              >
                <NotificationsActiveIcon fontSize="small" />{" "}
                {notifiedGames["Movie"] ? "Subscribed!" : "Stay Notified"}
              </Button>

              {/* Play Now Button (Bottom-Right) */}
              <Button
                variant="contained"
                sx={{
                  position: "absolute",
                  top: "55%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "#e9c87d",
                  color: "#000",
                  fontSize: { md: "14px", xs: "12px" },
                  padding: { md: "6px 16px", xs: "4px 12px" },
                  minWidth: "140px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  "&:hover": { backgroundColor: "#e9c87d" },
                }}
                onClick={() => handleRApidGameClick("Movie")}
              >
                <PlayArrowIcon fontSize="small" /> Play Now
              </Button>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              width: { md: "28%", xs: "90%" },
              borderRadius: "16px",
              padding: "12px",
              position: "relative",
              overflow: "hidden",
              "&::before, &::after": {
                content: '""',
                position: "absolute",
                width: "25%", // Adjust corner border size
                height: "25%",
                borderColor: "#e9c87d",
              },
              "&::before": {
                top: 0,
                left: 0,
                borderTop: "4px solid",
                borderLeft: "4px solid",
                borderColor: "#5b3b17",
              },
              "&::after": {
                bottom: 0,
                right: 0,
                borderBottom: "4px solid",
                borderRight: "4px solid",
                borderColor: "#5b3b17",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "100%",
                borderRadius: "16px",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {/* Image */}
              <img
                alt="profile"
                src={easter}
                style={{
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                  borderRadius: "16px",
                  objectFit: "cover",
                }}
              />

              {/* Black Overlay */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: {
                    md: "rgba(0, 0, 0,0.7)",
                    xs: "rgba(0, 0, 0,0.5)",
                  },
                  borderRadius: "16px",
                }}
              />

              {/* Ramadan Special Label (Centered) */}
              <Typography
                variant="h6"
                sx={{
                  position: "absolute",
                  top: "40%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  fontWeight: "bold",
                  fontSize: { md: "44px", xs: "34px" },
                  fontFamily: "Boogaloo",
                  color: "#fff",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
              >
                Easter Special
              </Typography>

              {/* Stay Notified Button (Top-Left) */}
              <Button
                variant="contained"
                sx={{
                  position: "absolute",
                  top: "32px",
                  left: "32px",
                  backgroundColor: "#e9c87d",
                  color: "#000",
                  fontSize: { md: "14px", xs: "12px" },
                  padding: { md: "6px 16px", xs: "4px 12px" },
                  minWidth: "140px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  "&:hover": { backgroundColor: "#e9c87d" },
                }}
                onClick={() => handleRApidNotificationClick("Easter")}
              >
                <NotificationsActiveIcon fontSize="small" />{" "}
                {notifiedGames["Easter"] ? "Subscribed!" : "Stay Notified"}
              </Button>

              {/* Play Now Button (Bottom-Right) */}
              <Button
                variant="contained"
                sx={{
                  position: "absolute",
                  top: "55%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "#e9c87d",
                  color: "#000",
                  fontSize: { md: "14px", xs: "12px" },
                  padding: { md: "6px 16px", xs: "4px 12px" },
                  minWidth: "140px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  "&:hover": { backgroundColor: "#e9c87d" },
                }}
                onClick={() => handleRApidGameClick("Easter")}
              >
                <PlayArrowIcon fontSize="small" /> Play Now
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>

      <Footer></Footer>
    </Box>
  );
}

export default RapidRiddleLanding;
